import React, { Fragment } from "react";

import {ContactForm} from './ContactForm'


export function Footer(){
    return (
      <Fragment>
        <footer
          id="footer"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingLeft: 20,
            paddingRight: 20,
          }}
        >
          <div className="inner">
            


             <ContactForm/>


            
            <section>
              <h2>Link Up With Me</h2>
              <ul className="icons">
                <li>
                  <a
                    href="tel:08169709728"
                    className="icon solid style2 fa-phone"
                  >
                    <span className="label">Phone</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/promise-shedrach-7a3189148/"
                    className="icon brands style2 fa-linkedin"
                  >
                    <span className="label">LinkedIn</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://m.facebook.com/promise.shedrach.7"
                    className="icon brands style2 fa-facebook-f"
                  >
                    <span className="label">Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/promiseshedo"
                    className="icon brands style2 fa-instagram"
                  >
                    <span className="label">Instagram</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/PromiseShedrach"
                    className="icon brands style2 fa-github"
                  >
                    <span className="label">Twitter</span>
                  </a>
                </li>
              </ul>
              <p>
                <i
                  className="fa fa-map-marker-alt"
                  style={{ paddingRight: 10 }}
                >
                  {" "}
                </i>{" "}
                Lagos, Nigeria.
              </p>
              <p>
                <i className="fa fa-envelope" style={{ paddingRight: 10 }}>
                  {" "}
                </i>
                <a href="mailto:promise.shedrach@yahoo.com">
                  promise.shedrach@yahoo.com
                </a>
              </p>
            </section>
            <ul className="copyright">
              <li>© 2020. Promise Shedrach.</li>
            </ul>
          </div>
        </footer>
      </Fragment>
    );
}